import { render, staticRenderFns } from "./LabelNormal.vue?vue&type=template&id=381a9d31&scoped=true"
import script from "./LabelNormal.vue?vue&type=script&lang=js"
export * from "./LabelNormal.vue?vue&type=script&lang=js"
import style0 from "./LabelNormal.vue?vue&type=style&index=0&id=381a9d31&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a9d31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('381a9d31')) {
      api.createRecord('381a9d31', component.options)
    } else {
      api.reload('381a9d31', component.options)
    }
    module.hot.accept("./LabelNormal.vue?vue&type=template&id=381a9d31&scoped=true", function () {
      api.rerender('381a9d31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/normal/LabelNormal.vue"
export default component.exports